import { Trans, useTranslation } from 'react-i18next';

// DF-0419 — what the customer reads under the anti-robot check when it has not
// produced a token. Before, the only answer was a toast that vanished in a few
// seconds and said « patientez », to customers who could wait forever: the
// check box nobody ticked, a browser Turnstile does not support, a script that
// never answered. This line stays until a token arrives, says what to do, and
// gives the restaurant's phone when the check will not get through.
export type CaptchaHint = 'none' | 'waiting' | 'interactive' | 'stuck';

interface Props {
  hint: CaptchaHint;
  phone: string | null;
  onRetry: () => void;
}

export default function CaptchaHelp({ hint, phone, onRetry }: Props) {
  const { t } = useTranslation();
  if (hint === 'none') return null;

  return (
    <div
      role="alert"
      data-testid="checkout-captcha-help"
      data-hint={hint}
      className="basis-full font-mono text-xs leading-snug text-ink"
    >
      <p className="m-0">
        <span aria-hidden="true">⚠</span> {t(`checkout.captcha.${hint}`)}
      </p>
      {hint === 'stuck' && (
        <>
          <button
            type="button"
            onClick={onRetry}
            data-testid="checkout-captcha-retry"
            className="mt-1 cursor-pointer rounded-btn-sm border-2 border-solid border-ink bg-paper px-2 py-[2px] font-mono text-[11px] text-ink"
          >
            {t('checkout.captcha.retry')}
          </button>
          {phone && (
            <p className="m-0 mt-1" data-testid="checkout-captcha-phone">
              <Trans
                i18nKey="checkout.captcha.callTo"
                values={{ phone }}
                components={{
                  tel: <a href={`tel:${phone}`} className="font-bold underline whitespace-nowrap" />,
                }}
              />
            </p>
          )}
        </>
      )}
    </div>
  );
}
